import "react-responsive-modal/styles.css";

import React, { useEffect, useLayoutEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { dataService } from "../../services/data.services";
import { Tooltip } from 'react-tooltip'
import CardHeader from "../../components/CardHeader";

import LoadingOverlay from "react-loading-overlay-ts";
import SupportTicketShimmer from "./Components/SupportTicketShimmer";
import ModalBox from "./Components/Modal";
import { checkPrivilege } from "../../CommonMethods/checkPrivilege";
import CardHeaders from "../../components/CardHeaders";

export default function SingleSupportTicket() {
    const [ticketData, setTicketData] = useState({});
    const { id } = useParams()
    const location = useLocation();
    const navigate = useNavigate()
    const [loading, setLoading] = useState(true);

    const [modal, setModal] = useState(false);
    const [severity, setSeverity] = useState('');
    const [status, setStatus] = useState('');
    const [severityNote, setSeverityNote] = useState('');
    const [statusNote, setStatusNote] = useState('');
    const [isTextTrimmed, setIsTextTrimmed] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        if (!modal) {
            setSeverity(ticketData.severity);
            setStatus(ticketData.status);
            setSeverityNote(ticketData.severity_note);
            setStatusNote(ticketData.status_note);
        }
    }, [modal]);

    useLayoutEffect(() => {
        const handleCheckText = () => {
            const subjectElement = document.querySelector('[data-testid="subject"]');
            if (subjectElement) {
                setIsTextTrimmed(subjectElement.scrollWidth > subjectElement.clientWidth);
            } else {
                // Element not found yet, try again later
                requestAnimationFrame(handleCheckText);
            }
        };

        handleCheckText();
    }, []);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await dataService.GetAPI(`admin-users/view-ticket/${id}`);
                if (response.data.data === null) {
                    setLoading(false)
                    navigate('/supports')
                } else {
                    setTicketData(response.data.data);
                    setSeverity(response.data.data.severity);
                    setStatus(response.data.data.status);
                    setSeverityNote(response.data.data.severity_note?.trim());
                    setStatusNote(response.data.data.status_note?.trim());
                    setLoading(false);
                }
            } catch (error) {
                console.error("Error fetching ticket data:", error);
                setLoading(false)
                navigate('/supports')
            }
        };

        fetchData();
    }, [id]);

    function getTicketType(User) {
        if (User) {
            const parts = User.split("_");
            return parts[0].charAt(0).toUpperCase() + parts[0].slice(1);
        }
        return '-'
    }

    const onSeverityChanged = async () => {
        const body = {
            ticket_id: ticketData.ticket_id,
            severity,
            severity_note: severityNote,
        }
        try {
            setIsLoading(true);
            const res = await dataService.PatchAPI(body, `admin-users/change-severity`);
            setIsLoading(false);
            if (!res.error) {
                window.location.reload();
            } else {
                console.error(error)
            }

        } catch (error) {
            setIsLoading(false);
            console.error(error)
        }
    }

    const onStatusChanged = async () => {
        const body = {
            ticket_id: ticketData.ticket_id,
            status,
            status_note: statusNote,
        }
        try {
            setIsLoading(true);
            const res = await dataService.PatchAPI(body, `admin-users/change-status`);
            setIsLoading(false);
            if (!res.error) {
                window.location.reload();
            } else {
                console.error(error)
            }

        } catch (error) {
            setIsLoading(false);
            console.error(error)
        }
    }

    const severityOptions = ['Low', 'Medium', 'High'];
    const statusOptions = ['Pending', 'In Progress', 'Completed'];
    const hasChangeStatus = checkPrivilege('change_support_ticket_status');


    return (
        <>
            {/* <div className=" flex-grow ml-[224px] w-full overflow-x-hidden">
                <div className="shadow-custom pt-5 pb-5  bg-white fixed w-full z-10">
                    <p className="text-[#4B4B4B] font-minionPro pb-4 pl-8 text-sm font-normal">
                        <span className="text-[#8E8E8E]">
                            Support  /{" "}
                        </span>
                        Support Tickets
                    </p>
                    <div className="flex items-center space-x-[14px] pl-6">
                        <img src="/assets/images/chevron-left.svg" alt="" onClick={() => navigate(-1)} />
                        <h1 className="font-playfair text-[#4B4B4B] text-xl font-semibold">
                            Support Tickets
                        </h1>
                    </div>
                </div> */}
            <CardHeaders
                paths={['Support']}
                pathurls={['/supports']}
                activePath="Support Tickets"
                header="Support Tickets"
                back={`/supports`}>
                <LoadingOverlay
                    active={Object.keys(ticketData).length === 0}
                    spinner
                    text="Loading Ticket details...">
                    <div className='min-h-[calc(100vh-110px)] bg-[#F5F5F5] px-4 py-[14px] relative '>
                        {loading ? <SupportTicketShimmer /> :
                            (<div className='bg-white h-full min-h-[calc(100vh-140px)] w-full rounded'>
                                <div className='pt-[46px] flex justify-between items-center'>
                                    <h1 className='ml-[20px] text-xl font-medium font-playfair text-[#4B4B4B]'>Ticket Details</h1>
                                </div>

                                <div className=' px-0 py-[14px] pt-0 font-minionPro'>
                                    <div className=" rounded-sm px-5 pt-[30px] pb-[22px]">
                                        <div className="flex -mx-1 flex-wrap" key={ticketData.id} >
                                            <div className="w-1/4 px-1 mb-[30px]">
                                                <div className="w-full">
                                                    <p className="text-base font-normal text-[#1F1F1F] text-left">Ticket ID</p>
                                                    <p data-testid="ticket-id"
                                                        className="text-base font-semibold text-[#1F1F1F] pt-2">
                                                        {ticketData.ticket_id} </p>
                                                </div>
                                            </div>
                                            <div className="w-1/4 px-1 mb-[30px]">
                                                <div className="w-full">
                                                    <p className="text-base font-normal text-[#1F1F1F] text-left">Name</p>
                                                    <p data-testid="name"
                                                        className="text-base font-semibold text-[#1F1F1F] pt-2">
                                                        {ticketData.name}
                                                    </p>
                                                </div>
                                            </div>
                                            <div className="w-1/4 px-1 mb-[30px]">
                                                <div className="w-full">
                                                    <p className="text-base font-normal text-[#1F1F1F] text-left">
                                                        Email Address
                                                    </p>
                                                    <p data-testid="email"
                                                        className="text-base font-semibold text-[#1F1F1F] pt-2 break-words">
                                                        {ticketData.email_address}
                                                    </p>
                                                </div>
                                            </div>
                                            <div className="w-1/4 px-1 mb-[30px]">
                                                <div className="w-full">
                                                    <p className="text-base font-normal text-[#1F1F1F] text-left">
                                                        Phone Number
                                                    </p>
                                                    <p data-testid="number"
                                                        className="text-base font-semibold text-[#1F1F1F] pt-2 break-words">
                                                        {ticketData.phone_number}
                                                    </p>
                                                </div>
                                            </div>
                                            <div className="w-1/4 px-1 mb-[30px]">
                                                <div className="w-full">
                                                    <p className="text-base font-normal text-[#1F1F1F] text-left">Subject</p>
                                                    <p data-testid="subject" data-tooltip-id="subject"
                                                        className="text-base font-semibold text-[#1F1F1F] pt-2
                                                    overflow-hidden overflow-ellipsis whitespace-nowrap pr-[10px]">
                                                        {ticketData.subject}
                                                    </p>
                                                    {isTextTrimmed &&
                                                        <Tooltip
                                                            id='subject'
                                                            place="bottom"
                                                            content={ticketData.subject}
                                                            className="max-w-[400px] break-words"
                                                        />}
                                                </div>
                                            </div>
                                            <div className="w-1/4 px-1 mb-[30px]">
                                                <div className="w-full">
                                                    <p className="text-base font-normal text-[#1F1F1F] text-left">Ticket Type</p>
                                                    <p data-testid="ticket-type"
                                                        className="text-base font-semibold text-[#1F1F1F] pt-2 
                                                    break-words text-justify ">
                                                        Ticket raised by {getTicketType(ticketData.user_type)}
                                                    </p>
                                                </div>
                                            </div>
                                            <div className="w-1/4 px-1 mb-[30px]">
                                                <div className="w-full">
                                                    <p className="text-base font-normal text-[#1F1F1F] text-left flex gap-4">
                                                        Severity
                                                        {hasChangeStatus && <img data-tooltip-id="severity"
                                                            data-testid="edit-severity"
                                                            src={`/assets/images/Support Edit.svg`}
                                                            alt='Edit'
                                                            onClick={() => setModal('severity')}
                                                        />}
                                                        <Tooltip
                                                            id='severity'
                                                            place="right"
                                                            content='Change Severity'
                                                        />
                                                    </p>
                                                    <p data-testid="severity"
                                                        className="text-base text-justify font-semibold text-[#1F1F1F] pt-2">
                                                        {ticketData.severity}
                                                    </p>
                                                </div>
                                            </div>
                                            <div className="w-1/4 px-1 mb-[30px]">
                                                <div className="w-full">
                                                    <p c className="text-base font-normal text-[#1F1F1F] text-left flex gap-4">
                                                        Status
                                                        {hasChangeStatus && <img data-tooltip-id='status'
                                                            data-testid="edit-status"
                                                            src={`/assets/images/Support Edit.svg`}
                                                            alt='Edit'
                                                            onClick={() => setModal('status')}
                                                        />}
                                                        <Tooltip
                                                            id='status'
                                                            place="right"
                                                            content='Change Status'
                                                        />
                                                    </p>
                                                    <p data-testid="status"
                                                        className="text-base font-semibold text-[#1F1F1F] pt-2">
                                                        {ticketData.status}
                                                    </p>
                                                </div>
                                            </div>
                                            <div className="w-1/2 px-1 mb-[30px] pr-6">
                                                <div className="w-full">
                                                    <h1 className="text-base font-normal text-[#1F1F1F] text-left">
                                                        Severity Note
                                                    </h1>
                                                    <p className="text-base font-semibold
                                                 text-[#1F1F1F] text-justify pt-2 break-words">
                                                        {ticketData.severity_note?.trim() !== '' ? ticketData.severity_note : '-'}
                                                    </p>
                                                </div>
                                            </div>
                                            <div className="w-1/2 px-1 mb-[30px]">
                                                <div className="w-full">
                                                    <h1 className="text-base font-normal text-[#1F1F1F] text-left">
                                                        Status Note
                                                    </h1>
                                                    <p className="text-base font-semibold
                                                 text-[#1F1F1F] text-justify pt-2 break-words">
                                                        {ticketData.status_note?.trim() !== '' ? ticketData.status_note : '-'}
                                                    </p>
                                                </div>
                                            </div>
                                            <div className="w-1/2 px-1 mb-[30px] pr-6">
                                                <div className="w-full">
                                                    <h1 className="text-base font-normal text-[#1F1F1F] text-left">
                                                        Description
                                                    </h1>
                                                    <p className="text-base font-semibold
                                                 text-[#1F1F1F] text-justify pt-2 break-words">
                                                        {ticketData.description?.trim() !== '' ? ticketData.description : '-'}
                                                    </p>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>)
                        }
                    </div>
                </LoadingOverlay>
            </CardHeaders>
            {/* </div> */}
            <ModalBox
                title='Change Severity'
                options={severityOptions}
                selectedValue={ticketData.severity}
                open={modal === 'severity'}
                setModal={setModal}
                setValue={setSeverity}
                setNote={setSeverityNote}
                note={severityNote}
                onChanged={onSeverityChanged}
                isLoading={isLoading}
            />
            <ModalBox
                title='Change Status'
                options={statusOptions}
                selectedValue={ticketData.status}
                open={modal === 'status'}
                setModal={setModal}
                setValue={setStatus}
                setNote={setStatusNote}
                note={statusNote}
                onChanged={onStatusChanged}
                isLoading={isLoading}
            />
        </>
    );
}